<template>
  <ScreenAdapter>
    <div id="main">
      <Header />
      <div class="platform-cover" :style="`background:url(${cover}) no-repeat center/cover`"></div>
      <Nav />
      <div class="eol-main-container">
        <div class="origin-content">
          <div class="content-header">
            <div class="text">认识生命的起源</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item,index in originData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <div class="precious-content">
          <div class="content-header">
            <div class="text">感悟生命的宝贵</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item,index in preciousData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <div class="create-content">
          <div class="content-header">
            <div class="text">创造生命的精彩</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item,index in createData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>

        <div class="accept-content">
          <div class="content-header">
            <div class="text">接纳生命的有限</div>
          </div>
          <div class="content-box">
            <div class="item" @click="jumpDetail(item)" v-for="item,index in acceptData" :key="index" :style="`background:url(${item.photo}) no-repeat center/cover`"></div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  </ScreenAdapter>

</template>

<script>
import Header from "@/components/Hzvtc/Header.vue"
import Nav from "@/components/Hzvtc/Nav.vue"
import Footer from "@/components/Hzvtc/Footer.vue"
import services from '../../../config/services'
import ScreenAdapter from "@/components/ScreenAdapter.vue"


export default {
  data () {
    return {
      cover: require("../../../assets/hzvtc/cover/vita.png"),
      school_code: localStorage.getItem("schoolCode"),
      originData: [], // 认识生命的起源
      preciousData: [], // 感悟生命的宝贵
      createData: [], // 创造生命的精彩
      acceptData: [], // 接纳生命的有限
    }
  },
  components: {
    Header,
    Nav,
    Footer,
    ScreenAdapter
  },
  async mounted () {
    await this.getListData()
  },
  methods: {
    // 请求列表数据
    async getListData () {
      // 认识生命的起源
      await services.getCourseList({ page: 1, size: 2, category_id: "153", school_code: this.school_code }).then(res => {
        this.originData = res.data.items
      })

      // 感悟生命的宝贵
      await services.getCourseList({ page: 1, size: 3, category_id: "154", school_code: this.school_code }).then(res => {
        this.preciousData = res.data.items
      })

      // 创造生命的精彩
      await services.getCourseList({ page: 1, size: 2, category_id: "155", school_code: this.school_code }).then(res => {
        this.createData = res.data.items
      })

      // 接纳生命的有限
      await services.getCourseList({ page: 1, size: 1, category_id: "156", school_code: this.school_code }).then(res => {
        this.acceptData = res.data.items
      })
    },
    jumpDetail (item) {
      window.open(`/center/${this.school_code}/hzvtc/detail?id=${item.id}&key=vita`, "_blank")
    },

    // 锚点定位
    // jumpPosition () {
    //   let that = this
    //   let position = that.$route.query.id
    //   if (position) {
    //     that.$nextTick(() => {
    //       let topVal = this.$refs[position].getBoundingClientRect().top
    //       let element = document.getElementsByClassName("outContainer")[0]
    //       element.scrollTop = topVal - 100
    //     })
    //   }
    // },
  },
}
</script>

<style lang="less" scoped>
#main {
  background: #fff;
}
.platform-cover {
  width: 100%;
  height: 510px;
}

.eol-main-container {
  width: 1200px;
  margin: 0 auto;
  position: relative;
  &::before {
    content: '';
    position: absolute;
    display: inline-block;
    top: -45px;
    left: 50%;
    transform: translateX(-50%);
    width: 1920px;
    height: 1335px;
    background: url('../../../assets/hzvtc/list/vita-t-bg.png') no-repeat
      center/cover;
  }
  .content-header {
    width: 100%;
    height: 42px;
    position: relative;
    z-index: 1;
    display: flex;
    justify-content: center;
    align-items: center;
    &::before,
    &::after {
      content: '';
      display: inline-block;
      width: 172px;
      height: 26px;
      position: absolute;
      top: 50%;
      background: url('../../../assets/hzvtc/common/list-ttile.png') no-repeat 0 /
        cover;
      transform: translateY(-40%);
      width: 400px;
    }
    &::before {
      left: 0;
    }
    &::after {
      right: 0;
    }
    .text {
      font-size: 42px;
      font-weight: bold;
      background: linear-gradient(180deg, #b70000 70%, #ffcba5 100%);
      -webkit-background-clip: text;
      -webkit-text-fill-color: transparent;
    }
  }
  .content-box {
    position: relative;
    z-index: 2;
  }
  .origin-content {
    .content-header {
      margin: 47px 0 40px;
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 578px;
        height: 325px;
        cursor: pointer;
        margin-bottom: 24px;
      }
    }
  }
  .precious-content {
    .content-header {
      margin: 45px 0 30px;
    }

    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        width: 380px;
        height: 214px;
        margin-bottom: 20px;
        cursor: pointer;
      }
    }
  }
  .create-content {
    .content-header {
      margin: 50px 0 40px;
    }
    .content-box {
      display: flex;
      justify-content: space-between;
      flex-wrap: wrap;
      .item {
        margin-bottom: 24px;
        cursor: pointer;
        width: 578px;
        height: 325px;
      }
    }
  }

  .accept-content {
    position: relative;
    top: 35px;
    margin: 0 0 25px;
    &::before {
      content: '';
      width: 1920px;
      height: 960px;
      background: url('../../../assets/hzvtc/list/value-c-bg.png') no-repeat
        center/cover;
      position: absolute;
      left: 50%;
      transform: translateX(-50%);
      top: 110px;
    }
    .content-header {
      margin: 40px 0 0;
    }
    .content-box {
      width: 100%;
      height: 730px;
      background: url('../../../assets/hzvtc/list/vita-b-news.png') no-repeat
        center/cover;
      position: relative;
      margin-top: -24px;
      .item {
        cursor: pointer;
        width: 817px;
        height: 459px;
        box-shadow: 0px 4px 4px 0px rgba(0, 0, 0, 0.25);
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
      }
    }
  }
}
::v-deep .footer-container {
  margin-top: -80px;
}
</style>